import React from 'react';

const ExportChartData = ({ rows }) => {
  // Function to export table data as a CSV file

  const exportToCSV = () => {
    const csvContent = [
      ["Fields", "Values"], // Headers
      ...rows, // Row data
    ]
      .map(row => row.join(',')) // Convert each row to a comma-separated string
      .join('\n'); // Join all rows with newlines to create the CSV format

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'table_data.csv'); // Filename for download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up link after download
  };

  return (
    <div>
        <div className='analyticTableHeader'>
        <h2>Analytic Table</h2>
        <button onClick={exportToCSV}>Export to CSV</button>
        </div>
      <table>
        <thead>
          <tr>
            <th>Fields</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ExportChartData;
